import { AdditionalStage } from '../types';
import { AppState } from '../../rootReducer';
import { AdditionalStagesState } from '../types';

export const getState = (state: AppState): AdditionalStagesState => state.additionalStagesReducer;

export const getAdditionalStagesList = (state: AppState): AdditionalStage[] =>
    state.additionalStagesReducer.additionalStages || [];

export const isLoading = (state: AppState): boolean => state.additionalStagesReducer.isLoading;
